module.exports = __webpack_public_path__ + "img/bim (14).179d05cd.png";